<template>
  <nav class="bg-transparent d-flex text-center justify-content-around mb-5 position-absolute w-100 mt-4">
      <h1>Lollapalooza Lineup Generator</h1>
      <!-- <nav class="d-flex align-items-center">
        <RouterLink to="/" class="mx-2">Pódio Artistas</RouterLink>
        <RouterLink to="/about" class="mx-2">Pódio Músicas</RouterLink>
      </nav> -->
  </nav>
</template>

<style>
.border-green{
  border-bottom: var(--bs-border-width) var(--bs-border-style) #1FDF64 !important;
}

a{
  color: white;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 500;
}


</style>

<script setup lang="ts">
</script>